import { render } from "./IconChevronLeft.vue?vue&type=template&id=4040c84e"
const script = {}
script.render = render

export default script